import * as Types from './types';

const fetchUserPermission = () => ({
  type: Types.FETCH_USER_PERMISSION,
  meta: {
    async: true,
    api: 'publicador',
    path: `/publicador/api/v1/user/validate`,
    method: 'GET'
  }
});

export { fetchUserPermission };
